import { CSSProperties, ReactNode, useRef } from 'react';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryCart.module.scss';
import { CSSTransition, TransitionStatus } from 'react-transition-group';

type TransitionStyles = {
  [name in TransitionStatus]?: CSSProperties;
};

const DURATION = 300;
const DEFAULT_STYLE: CSSProperties = {
  transitionProperty: 'transform',
  transitionDuration: `${DURATION}ms`,
  transform: 'translateX(101%)'
};

const TRANSITION_EASE_IN = {
  transitionTimingFunction: 'ease-in'
};
const TRANSITION_EASE_OUT = {
  transitionTimingFunction: 'ease-out'
};

const TRANSITION_STYLES: TransitionStyles = {
  entering: { transform: 'translateX(100%)' },
  entered: { transform: 'translateX(0)' }
};

export default function PhotoGalleryCartTransition({ children }: { children: ReactNode }) {
  const [{ showCart }] = usePhotoGalleryContainer();
  const nodeRef = useRef(null);

  return (
    <CSSTransition in={showCart} timeout={0}>
      {state => (
        <div
          className={styles.CartContainer}
          ref={nodeRef}
          style={{
            ...DEFAULT_STYLE,
            ...TRANSITION_STYLES[state],
            ...(state === 'entering' ? { ...TRANSITION_EASE_OUT } : {}),
            ...(state === 'exiting' ? { ...TRANSITION_EASE_IN } : {})
          }}
        >
          {children}
        </div>
      )}
    </CSSTransition>
  );
}
